//import ConnectionHis from './ConnectionHis';

import { Double } from "react-native/Libraries/Types/CodegenTypes";
import { BookItem, EvtData, Lookback, } from "./Constants";

/*   ====================================================================   */

export interface ISymbolInfo
{
  props     : Data;
  Remove    : (sToken: string)=>void;
  bindEvent : (onEvent    : (() => void), 
               bSubscribe : boolean) => void
}

/*   ====================================================================   */

export class AccData
{
  public acc_id                 = "";
  public fcm_id                 = "";
  public ib_id                  = "";
  public key                    = "";
  public currency               = "";
  public sub_pnl                = false;

  public acc_balance? : number    = undefined;
  public pnl? : number            = undefined;
  public pnl_open? : number       = undefined;
  public pnl_closed? : number     = undefined;
  public working_buys? : number   = undefined;
  public working_sells? : number  = undefined;
  public net_qty? : number        = undefined;

  public altv? : number           = undefined;

  public fill_buy_qty? : number   = undefined;
  public fill_sell_qty? : number  = undefined;

  public open_net_qty? : number   = undefined;

  //public orders = new Map<string, string[]>();

  //public positions : PosData[] = new Array(0);

  constructor(sFCMId : string,
              sIBId  : string,
              sAccId : string,
              sKey   : string)
  {
  this.fcm_id = sFCMId;
  this.ib_id  = sIBId;
  this.acc_id = sAccId;
  this.key    = sKey;
  }
}

/*   ====================================================================   */

export class Bracket
{
public targets : BracketData[] = Array(0);
public stops   : BracketData[] = Array(0);

/*   ---------------------------------------------------------------------   */

static Find(oBr     : BracketData[],
            iLevel  : number) : number
{
for (let i = 0; i < oBr.length; i++)
  {
  if (oBr[i].level == iLevel)
    {
    return(i);
    }
  }

return(-1);
}

/*   ---------------------------------------------------------------------   */

static FindAndDelete(oBr     : BracketData[],
                     iLevel  : number) : boolean
{
for (let i = 0; i < oBr.length; i++)
  {
  if (oBr[i].level == iLevel)
    {
    oBr.splice(i, 1);
    return(true);
    }
  }

return(false);
}

}

/*   =====================================================================   */

export class SysData
{
public label                = "";
public value                = "";
public system               = "";
public uri                  = "";
public color                = "black";
public requested            = false;

public gateways             : GwyData[] = new Array(0);

constructor(sName   : string,
            sSystem : string = "")
{
this.label  = sName;
this.value  = sName;

if (sSystem)
  this.system = sSystem;
}
}

/*   ====================================================================   */

export class GwyData
{
public label = "";
public value = "";
public uri   = "";
public color = "black";
public agg   = false;

constructor(sName : string,
            sUri  : string,
            bAgg? : boolean | undefined)
{
this.label = sName;
this.value = sName;
this.uri   = sUri;
this.agg   = bAgg? true : false;
}
}

/*   ====================================================================   */

export class MBOData
{
  dPrice         : number = 0;

  iQty           : number = 0;

  iQtyAhead      : number = 0;
  iQtyBehind     : number = 0;

  iOrdersAhead   : number = 0;
  iOrdersBehind  : number = 0;

  iSeqNo         : number = 0;

  sExchOrdId     : string = "";
  
  iQP            : number = 0;

  bBuy                    = false;

  oOrders        : Map<string, MBOOrder> = new Map<string, MBOOrder>();
  //oQP?           : number[];
  //oSizes?        : number[];
  //iAnchor
  }

/*   =======================================================================  */

export class MBOOrder
{
  iQP   : number;
  iSize : number;

  constructor(iQP : number, iSize: number)
  {
  this.iQP   = iQP;
  this.iSize = iSize;
  }
}

/*   =======================================================================  */

export class OrdData
{
  public symbol                 = "";
  public exchange               = "";
  public token                  = "";

  public basket_id              = "";

  public fcm_id                 = "";
  public ib_id                  = "";
  public acc_id                 = "";
  public acc_key                = "";

  public limit_price            : number | undefined  = undefined;
  public trigger_price          : number | undefined  = undefined;
  public fill_price             : number | undefined  = undefined;

  //public oMBO                   : MBOData | undefined = undefined;

  public price_type             = "";
  public price_type_api         = 0;
  public txn_type_api           = 0;
  public txn_type               = "";
  public qty                    = 0;
  
  public exch_order_id          = "";
  public route                  = "";

  public status                 = "";
  public remarks                = "";

  public completion_reason      = "";

  public time: number|undefined = undefined;

  public bracket_type?         : string;
  public org_basket_id?        : string;
  public linked_orders?        : string;

  public oBrData?              : BracketData;
  public sSelId?               : string;

  constructor()
  {
  }
}

/*   ====================================================================   */

export class BracketData
{
public qty_org      : number = 0;
public qty_rel      : number = 0;
public level        : number = 0;
}

/*   ====================================================================   */

export class ChartOrd
{
  public iBuys                 = 0;
  public iSells                = 0;
}

/*   ====================================================================   */

export class OrdDefault
{
  cancel_after_en?   : boolean;
  cancel_after_sec   : number = 10;

  cancel_at_en?      : boolean;
  cancel_at_hr       : number = 0;
  cancel_at_min      : number = 0;
  cancel_at_sec      : number = 0;
  cancel_at_type     : number = 1;
  //cancel_at_err?     : boolean;

  bracket_target_en? : boolean;
  bracket_target_tks : number = 10;
  bracket_stop_en?   : boolean;
  bracket_stop_tks   : number = 10;

  bracket_stop_trl?  : boolean;
}

/*   ====================================================================   */

export class PosData
{
  public acc_key                          = "";
  public token                            = "";

  public net_qty? :number                 = undefined;
  public open_pnl? :number                = undefined;
  public closed_pnl? :number              = undefined;

  public total_pnl? :number               = undefined;

  public open_pos_qty? :number            = undefined;
  public closed_pos_qty? :number          = undefined;

  public order_buy_qty? :number           = undefined;
  public order_sell_qty? :number          = undefined;

  public avg_open_fillprice? :number      = undefined;

  public buy_qty? :number                 = undefined;
  public sell_qty? :number                = undefined;
  
  public orders:string[]                  = new Array(0);
  public orders_working:string[]          = new Array(0);


  constructor(sAccKey : string,
              sToken  : string)
  {
  this.acc_key    = sAccKey;
  this.token      = sToken;
  }
}

/*   ====================================================================   */

export class ChartData
{
  public open: number  = 0;
  public close: number = 0;
  public high: number  = 0;
  public low: number   = 0;
  public vol: number   = 0;

  constructor(open, close, high, low, vol)
  {
    this.open  = open;
    this.close = close;
    this.high  = high;
    this.low   = low;
    this.vol   = vol;
  }
}

/*   ====================================================================   */

export class Data
{
  public symbol                 = "";
  public symbol_name            = "";
  public product_code           = "";
  public is_evt_enabled         = false;
  public instr_type             = "";
  public trading_symbol         = "";
  public bContSymbol            = false;
  public trading_exchange       = "";
  public exchange               = "";
  public token                  = "";
  public mode                   = "";
  //public trading_token?: string = undefined;
  public low? : number          = undefined;
  public last? : number         = undefined;
  //public last_got               = false;
  public high? : number         = undefined;
  public lastKey                = "0.0";
  public last_size? : number    = undefined;
  public bid? : number          = undefined;
  public bid_size? :number      = undefined;
  public ask? : number          = undefined;
  public ask_size? : number     = undefined;
  public vol                    = 0;

  public close?      : number   = undefined;
  public settlement? : number   = undefined;
  public adj_close? : number    = undefined;
  
  public expiry_time? : number;
  
  public book_levels            = 100;
  public sv_account? : string;

  public nc                     = 0.0;
  public pc                     = 0.0;
  public time                   = 0;
  public f2qp                   = 2;
  public qpc                    = 0.01;
  public display_fmt            = "";

  public closes:number[]        = new Array(0);// //new [0];  
  public ohlc:ChartData[]       = new Array(0);
  public highs:number[]         = new Array(0);
  public lows:number[]          = new Array(0);
  public vols:number[]          = new Array(0);

  public min? : number          = undefined;
  public max? : number          = undefined;
  public times:string[]         = new Array(0);
  public close_times:number[]   = new Array(0);

  public lookback:Lookback;
  public rq_bars                = false;
  public closes_got             = false;

  public update_chart           = false;
  public update_chart_rr        = false;
  public update_orders          = false;

  public sub_bars               = false;
  // public sub_ob                 = false;
  public sub_mkt                = false;
  public sub_opt                = false;
  public sub_pnl                = false;
  public year_closes:number[]   = new Array(0);
  public mode_got               = false;
  public trade_got              = false;
  public bbo_got                = false;
  public visible_index          = 0;
  public evt_got                = false;
  public evt_avbl               = false;
  public msgs                   = 0;
  public msgs_curr              = 0;
  public ref_data_got           = false;

  // public book:BookItem[]        = new Array(0);

  public curr_page              = 0;
  
  public evt?     : Map<string, EvtData>;
  public evt_exp? : EvtData[];
  public evt_index              = 0;
  
  public evt_org_token          = "";
  
  constructor(symbol   : string,
              exchange : string,
              token    : string,
              lookback : Lookback)
  {
  this.symbol   = symbol;
  this.exchange = exchange;
  this.token    = token;
  this.lookback = lookback;
  }
  }

/*   ====================================================================   */

export class OBData
  {
  public book_levels            = 1000;
  public sub_ob                 = 0;
  public f2qp                   = 2;
  public qpc                    = 0.01;
  public clear                  = false;
  public compress               = false;
  public book:BookItem[]        = new Array(0);
  public oFMData : Data | null  = null;
  public oData   : Data | null  = null;
  

  public oMBOData? : MBOData[]; 

  //public opt?       : OptItem[];
  //public oOptStore? : Map<string, OptItem[]>; 

  /*   -------------------------------------------------------------------   */

  constructor()
  {
  this.FindItem = this.FindItem.bind(this);
  }

  /*   -------------------------------------------------------------------   */

  FindItem(dPrice : number)
  {
  for (let i = 0, j = this.book.length; i < j; i++)
    {
    if (this.book[i].Price == dPrice)
      return(this.book[i]);  
    }
  }

  /*   -------------------------------------------------------------------   */

  }

/*   ====================================================================   */

